module.exports = __webpack_public_path__ + "static/mascot-design-cdd54f2e1f51e5b05722d70718eb87ae.png";